import { html } from 'lit';
import componentStyles from './cta-links.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';

/**
 * Links for CTAs.
 *
 * @element cta-links
 */

export default class CtaLinks extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      items: { type: Object },
    };
  }

  render() {
    return html`
      <div class="cta-links">
        <ul>
          ${this.items.map(item => {
            return html`
              <li class="cta-links__item">
                <hf-link-button
                  href="${item.url}"
                  target="_self"
                  icon="${item.icon}"
                  iconDirection="${item.iconDirection}"
                  linkClass="btn__link--cta-links"
                  >${item.text}</hf-link-button
                >
              </li>
            `;
          })}
        </ul>
      </div>
    `;
  }
}

customElements.define('hf-cta-links', CtaLinks);
